import { ReactElement, ReactNode } from 'react';

import { IFeatureFlagMap } from '../interfaces/IFeatureFlagMap';
import { useFeatureFlags } from '../useFeatureFlags/useFeatureFlags';

import { displayName } from './Feature.qa';

interface IFeatureProps {
    flag: string;
    flagEnabled?: boolean;
    flagDisabled?: boolean;
    children: ReactNode;
}

export function Feature (props: IFeatureProps): ReactElement<any, any> | null {
    const {
        flag,
        flagEnabled = true,
        flagDisabled = false,
    }: IFeatureProps = props;

    const flags: IFeatureFlagMap = useFeatureFlags();

    if (flagEnabled && flagDisabled) {
        throw new Error(
            'Feature cannot have both "flagEnabled" and "flagDisabled"',
        );
    }

    if ((flagEnabled && flags[flag]) || (flagDisabled && !flags[flag])) {
        return (props.children as any) || null;
    }

    return null;
}

Feature.displayName = displayName;
